var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 96 960 960"}},[_c('title',[_vm._v("Vai")]),_vm._v(" "),_c('path',{attrs:{"d":"m375 816-43-43 198-198-198-198 43-43 241 241-241 241Z","fill":"#11181C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }